/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/control-has-associated-label */

import React, {
    useState, useEffect, useCallback, useContext,
} from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import SlidingPane from 'react-sliding-pane';
import Modal from 'react-modal';
import { distributorService } from '../../service/distributor.service';
import HeaderContext from '../../Components/Context/HeaderContext';
import Pagination from '../../Components/Pagination';
import { GenerateDate } from '../../redux/helper/DateConverter';
import FilterModal from './FilterModal';
import EmptyScreen from '../../Components/GlobalEmplyPage';
import ThreeDotsLoader from '../../Components/LoadingDots';
import TransactionsListSkeleton from '../Transactions/transactionlistSkeleton';
import { AccessPrevilegesFunction } from '../../constants/GlobalAccessFunction';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

function BulkOfferListing() {
    const [offers, setOffers] = useState([]);
    const [filter, setFilter] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [filterQuery, setFilterQuery] = useState({
        page: 1,
        limit: 8,
        sort: 'created_at desc',
    });
    const [totalPage, setTotalPage] = useState('');
    const [alldata, setalldata] = useState({});
    const [loading, setLoading] = useState(true);
    const [isEditId, setisEditId] = useState('');
    const [FilterModalOpen, setFilterModal] = useState(false);
    const [export1, setExport] = useState(false);
    const [OpenPopup, setOpenPopup] = useState('');
    const [actvloader, setactvloader] = useState(false);
    const [selectedUser, setselectedUser] = useState({});
    const [showPopup, setshowPopup] = useState(false);
    const [title, settitle] = useState(' Otp Verification Successful!');
    const [isLoaded, setisLoaded] = useState(true);
    const [emptyData, setEmptyData] = useState(false);

    const [selected, setselected] = useState({
        offer_type: [],
        industrial_pocket: [],
        status: '',
        start_date: '',
        end_date: '',
    });

    const {
        SetSuccessMessage,
    } = useContext(HeaderContext);

    const handleFetch = useCallback((query) => {
        const url = new URLSearchParams(query).toString();
        setLoading(true);
        distributorService.BulkOfferList(url).then((res) => {
            if (res.data.data.success_status) {
                if (res.data.data.url) {
                    SetSuccessMessage('Export successful');
                    delete filterQuery.export;
                    setFilterQuery(filterQuery);
                    window.open(res.data.data.url, '_blank');
                    setTimeout(() => {
                        SetSuccessMessage('');
                    }, 2000);
                } else {
                    if (res.data.data.Items.length === 0) {
                        setLoading(false);
                        setEmptyData(true);
                    } else {
                        setEmptyData(false);
                        setLoading(false);
                    }
                    setOffers(res.data.data.Items);
                    setalldata(res.data.data.Items);
                    setCurrentPage(res.data.data.current_page);
                    setTotalPage(res.data.data.number_of_pages);
                }
            }
        });
        setLoading(false);
    }, []);

    const handleFilter = (value, key) => {
        filter[key] = value;
        setFilter(filter);
        filterQuery[key] = value;
        setFilterQuery(filterQuery);
        handleFetch(filterQuery);
    };

    const handlePageClick = async (data) => {
        const page = data.selected + 1;
        setCurrentPage(page);
        handleFilter(page, 'page');
    };

    const handleColorStatus = (status) => {
        let res = '';
        if (status === '1') {
            res = 'border-[#D7F8DC] bg-[#D7F8DC] px-1 w-[82px]';
        }
        if (status === '0' || status === '0') {
            res = 'border-[#808285] bg-[#808285] text-[#FFFFFF] px-1 w-[82px]';
        }
        if (status === '3') {
            res = 'border-[#FFF2DE] bg-[#FFF2DE] text-[#555259] px-1 w-[82px]';
        }
        if (status === '2') {
            res = 'border-[#F8E1E4] bg-[#F8E1E4] text-[#555259] px-1 w-[82px]';
        }
        return res;
    };

    const handleImage = (status) => {
        let res = '';
        if (status === '1') {
            res = 'Active-icon.svg';
        }
        if (status === '0') {
            res = 'inactive-1.svg';
        }
        if (status === '3') {
            res = 'draft.svg';
        }
        if (status === '2') {
            res = 'expired-1.svg';
        }
        return res;
    };

    const handleActivateOrDeactivate = (status1, code1) => {
        setactvloader(true);
        distributorService.BulkofferActiveOrDeactivate(status1, code1).then((res) => {
            if (!res.error && res.data.success_status) {
                settitle(res.data.message);
                setshowPopup(true);
                setOpenPopup('');
                setactvloader(false);
                setisLoaded(true);
                setTimeout(() => {
                    setshowPopup(false);
                }, 4000);
                handleFetch();
            } else {
                setactvloader(false);
            }
        });
    };

    const previlegeassigned = AccessPrevilegesFunction('bulk_offer');

    useEffect(() => {
        handleFetch(filterQuery);
    }, [handleFetch]);

    return (
        <div className="py-6 main-screen">
            <div className="flex justify-between items-center pb-[18px]">
                <h5 className="text-xs4 font-normal text-[#555259]">Bulk Offer</h5>
                <div className="flex items-center">
                    <button
                        type="button"
                        className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                        style={{ border: '2px solid #E9EDF4' }}
                        data-bs-toggle="modal"
                        data-bs-target="#filtermodal"
                        onClick={() => setFilterModal(true)}
                    >
                        Filter
                    </button>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input type="text" value={filterQuery.search !== undefined ? filterQuery.search : ''} name="search" id="search" className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]" placeholder="Search" onInput={(e) => handleFilter(e.target.value, 'search')} />
                        <img src="images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    <div className="mr-2 dropdown relative">
                        <button
                            type="button"
                            onClick={() => { setExport(!export1); }}
                            id="exportDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg"
                        >
                            Export
                        </button>
                        <ul className={`dropdown-menu sm:min-w-[85px] min-w-[120px] absolute ${export1 ? '' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[40] sm:p-3.5 p-1.5`} aria-labelledby="exportDropdown">
                            <li onClick={() => { handleFilter('csv', 'export'); setExport(!export1); }} className="sm:py-1 py-0.5 export border-b border-[#D8D8D8]">
                                <a className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" href="#">CSV</a>
                            </li>
                            <li onClick={() => { handleFilter('pdf', 'export'); setExport(!export1); }} className=" sm:py-1 py-0.5 border-b border-[#D8D8D8]">
                                <a className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" href="#">PDF</a>
                            </li>
                            <li onClick={() => { handleFilter('excel', 'export'); setExport(!export1); }} className=" sm:py-1 py-0.5">
                                <a className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" href="#">Excel</a>
                            </li>
                        </ul>
                    </div>
                    {previlegeassigned === true
                        ? (
                            <Link to="/bulk-offers/create" className="h-[35px] mr-2 text-xs2 font-semibold text-[#FFFFFF] w-[107px] bg-[#555259] border border-[#555259] rounded-lg text-center flex justify-center items-center">
                                Create Offer
                            </Link>
                        ) : null}
                </div>
            </div>
            <div>
                <div
                    className="overflow-auto dropdown-menu pb-7 relative z-10"
                    style={{ height: 'calc(100vh - 298px)' }}
                >
                    {!loading ? (
                        <>
                            {offers && offers.length > 0 && (
                                <table className="w-full table-auto relative z-[2]">
                                    <thead className="sticky top-0 left-0 z-[51]">
                                        <tr className="bg-[#555259] h-10">
                                            <th className="py-[5px] px-6 rounded-bl-lg rounded-tl-lg min-w-[142px] text-start" scope="col">
                                                <span className="text-sm29 font-bold text-[#FFFFFF]">
                                                    Offer Code
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[130px]">
                                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                    Type
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{
                                                                rotate: filterQuery.sort === 'industrial_pocket asc' ? 180 : 0,
                                                            }}
                                                            // className={`${filterQuery.sort === 'status' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                if (filterQuery.sort === 'industrial_pocket asc') {
                                                                    handleFilter('industrial_pocket desc', 'sort');
                                                                } else if (filterQuery.sort === 'industrial_pocket desc') {
                                                                    handleFilter('industrial_pocket asc', 'sort');
                                                                } else { handleFilter('industrial_pocket asc', 'sort'); }
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[200px] text-start">
                                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                    Start Date
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{
                                                                rotate: filterQuery.sort === 'start_date asc' ? 180 : 0,
                                                            }}
                                                            // className={`${filterQuery.sort === 'status' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                if (filterQuery.sort === 'start_date asc') {
                                                                    handleFilter('start_date desc', 'sort');
                                                                } else if (filterQuery.sort === 'start_date desc') {
                                                                    handleFilter('start_date asc', 'sort');
                                                                } else { handleFilter('start_date asc', 'sort'); }
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[200px] text-start">
                                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                    End Date
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{
                                                                rotate: filterQuery.sort === 'end_date asc' ? 180 : 0,
                                                            }}
                                                            // className={`${filterQuery.sort === 'status' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                if (filterQuery.sort === 'end_date asc') {
                                                                    handleFilter('end_date desc', 'sort');
                                                                } else if (filterQuery.sort === 'end_date desc') {
                                                                    handleFilter('end_date asc', 'sort');
                                                                } else { handleFilter('end_date asc', 'sort'); }
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[160px]">
                                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                    Status
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{
                                                                rotate: filterQuery.sort === 'offer_status asc' ? 180 : 0,
                                                            }}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                if (filterQuery.sort === 'offer_status asc') {
                                                                    handleFilter('offer_status desc', 'sort');
                                                                } else if (filterQuery.sort === 'offer_status desc') {
                                                                    handleFilter('offer_status asc', 'sort');
                                                                } else { handleFilter('offer_status asc', 'sort'); }
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="rounded-tr-lg rounded-br-lg py-[5px] px-7 min-w-[66px]">
                                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center" />
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {offers && offers.length > 0 && offers.map((offer, offerIndex) => (
                                            <AnimatePresence>
                                                <motion.tr
                                                    className="bg-[#FDFDFE] border-b border-[#DFEAF7] relative"
                                                    animate={{ opacity: 1, x: 0 }}
                                                    key={`offer-${offerIndex}`}
                                                    initial={{ opacity: 0, x: -10 }}
                                                    exit={{ opacity: 0, x: -10 }}
                                                    transition={{ duration: 0.15 }}
                                                    style={{ zIndex: `${50 - offerIndex}` }}
                                                >
                                                    <td className="text-sm font-normal text-[#090406] py-[26px] px-7 text-start">
                                                        {offer?.offer_code}
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-[26px] px-7 text-start">
                                                        {offer?.industrial_pocket}
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-[26px] px-7 text-start">
                                                        {GenerateDate(offer.start_date)}
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-[26px] px-7 text-start">
                                                        {GenerateDate(offer.end_date)}
                                                    </td>
                                                    <td className="text-sm font-normal text-[#555259] py-[26px] px-7 text-start">
                                                        <a
                                                            href="#"
                                                            className={`flex rounded-sm border-2 ${handleColorStatus(offer.offer_status)} py-0.5 pr-1.5 w-fit`}
                                                        >
                                                            {/* <img src={`images/${user.offer_status === '1' ? 'Active-icon.svg' : 'inactive-1.svg'}`} alt="icon" className="px-2" /> */}
                                                            <img src={`images/${handleImage(offer.offer_status)}`} alt="icon" className="px-2" />
                                                            {offer.offer_status === '0' ? 'Inactive' : offer.offer_status === '1' ? 'Active' : offer.offer_status === '2' ? 'Expired' : 'Draft'}
                                                        </a>
                                                    </td>
                                                    <td
                                                        onClick={() => {
                                                            if (isEditId === offerIndex) {
                                                                setisEditId('');
                                                            } else {
                                                                setisEditId(offerIndex);
                                                            }
                                                        }}
                                                        className="py-2.5 px-7 right-0 bg-[#ffffffe6]"
                                                        style={{
                                                            background: 'rgba(255, 255, 255, 0.45)',
                                                            backdropFilter: 'blur(5.5px)',
                                                        }}
                                                    >
                                                        <div
                                                            className="dropdown relative flex justify-center cursor-pointer"
                                                        >

                                                            <button className="dropdown-toggle" type="button" id="dropdownMenuButton111" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <img src="/images/more-vertical.svg" alt="icon" className="cursor-pointer" />
                                                            </button>
                                                            {isEditId === offerIndex && (
                                                                <ul className="dropdown-menu min-w-[200px] absolute show top-0 right-12 bg-[#FFFFFF] rounded-[10px] shadow-s2" aria-labelledby="actionButton">
                                                                    <Link to={`/bulk-offers/view?code=${offer.offer_code}`}>
                                                                        <li
                                                                            className="inline-block dropdown-item w-full py-2"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#update-category"
                                                                        >
                                                                            <p className="text-sm font-normal text-[#000000] cursor-pointer text-center">
                                                                                View Offer
                                                                            </p>
                                                                        </li>
                                                                    </Link>
                                                                    <Link to={`/bulk-offers/subscribers/${offer?.offer_code}`}>
                                                                        <li
                                                                            className="inline-block dropdown-item w-full py-2"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#updateInvoice"
                                                                        >
                                                                            <p className="text-sm font-normal text-[#000000] cursor-pointer text-center">
                                                                                View Subscribers
                                                                            </p>
                                                                        </li>
                                                                    </Link>
                                                                    <li
                                                                        className="inline-block dropdown-item w-full"
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#uploadInvoice"
                                                                    >
                                                                        <p className="text-sm font-normal text-[#000000] cursor-pointer text-center">
                                                                            {(offer.offer_status !== '1' && offer.offer_status !== '0' && offer.offer_status !== '2')
                                                                    && (
                                                                        <li className="px-5 py-1.5">
                                                                            <Link to={`/bulk-offers/${offer.offer_code.split('/').join('-')}/update`} className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block">Edit</Link>
                                                                        </li>
                                                                    )}
                                                                            {(offer.offer_status === '1' || offer.offer_status === '3')
                                                                    && (
                                                                        <li
                                                                            className="px-5 pt-1.5 pb-5 cursor-pointer"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#deactivateUserModal"
                                                                            onClick={() => {
                                                                                setselectedUser(offer);
                                                                                setOpenPopup('active');
                                                                                setisEditId('');
                                                                            }}
                                                                        >
                                                                            <a
                                                                                className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block"
                                                                            >
                                                                                {offer.offer_status === '1' ? 'Deactivate' : 'Activate'}

                                                                            </a>
                                                                        </li>
                                                                    )}
                                                                        </p>
                                                                    </li>
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </td>
                                                </motion.tr>
                                            </AnimatePresence>
                                        ))}
                                    </tbody>
                                </table>
                            )}

                            {!loading && offers && offers.length === 0 && (
                                <EmptyScreen
                                    search="yes"
                                    text="no Offers Found"
                                    url="/bulk-offers/create"
                                    action="Create New"
                                    // title="Offers"
                                    all={filterQuery.search === 0 ? 'under searched term' : 'found'}
                                />
                            )}
                        </>

                    ) : <TransactionsListSkeleton />}
                </div>

                <Modal
                    style={customStyles}
                    isOpen={OpenPopup !== ''}
                    ariaHideApp={false}
                    onRequestClose={() => setOpenPopup('')}
                    onClick={() => {
                        setOpenPopup('');
                        setactvloader(false);
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none max-w-[441px]">
                        <div
                            className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                        >
                            <div className="modal-header flex flex-shrink-0 items-center justify-between p-4 pt-7 rounded-t-md">
                                <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel">
                                    {(selectedUser.offer_status === '3' ? 'Activate' : 'Deactivate')}
                                    {' '}
                                    {' '}
                                    Offer
                                </h5>

                                <button
                                    type="button"
                                    className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body relative px-9 pt-2 pb-6 text-center">
                                <p className="text-xs6 font-normal text-[#555259]">
                                    {`${selectedUser.offer_code}`}
                                    {' '}
                                    is currently
                                    {' '}
                                    {selectedUser.offer_status === '1' ? 'Active' : 'Draft'}
                                    . Are you sure you
                                    {' '}
                                    want to
                                    {' '}
                                    {selectedUser.offer_status === '1' ? 'Deactivate' : 'Activate'}
                                    ?
                                </p>
                            </div>

                            <div className="modal-footer flex flex-shrink-0 flex-wrap justify-evenly pb-6 rounded-b-md">
                                <button
                                    onClick={() => {
                                        setOpenPopup('');
                                        setactvloader(false);
                                    }}
                                    type="button"
                                    className="border border-[#555259] bg-[#ffffff] text-base font-normal text-[#555259] py-3 px-14 rounded-lg"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="border border-[#673593] bg-[#555259] text-base font-normal text-[#ffffff] py-3 px-14 rounded-lg"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => handleActivateOrDeactivate(selectedUser.offer_status === '3' ? 'activate' : 'deactivate', selectedUser.offer_code)}
                                >
                                    {actvloader ? <ThreeDotsLoader /> : 'Yes'}
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

                {!loading && offers && offers.length > 0 && (
                    <Pagination
                        handlePageClick={handlePageClick}
                        totalPage={totalPage}
                        List={alldata}
                        currentPage={currentPage}
                    />
                )}
                <SlidingPane
                    from="right"
                    isOpen={FilterModalOpen}
                    width="30%"
                    className="z-50"
                    hideHeader
                    onRequestClose={() => setFilterModal(false)}
                >
                    <FilterModal
                        setFilterModal={setFilterModal}
                        handleFetch={handleFetch}
                        filterQuery={filterQuery}
                        setFilterQuery={setFilterQuery}
                        selected={selected}
                        setselected={setselected}
                    />
                </SlidingPane>
            </div>
        </div>
    );
}

export default BulkOfferListing;
